module.exports = __webpack_public_path__ + "static/media/im_triangle.a07818b9.svg";